import React, { useEffect, useRef } from 'react';

export default function Cursor() {
  const dotRef  = useRef(null);
  const ringRef = useRef(null);
  const pos     = useRef({ x: 0, y: 0 });
  const ring    = useRef({ x: 0, y: 0 });
  const raf     = useRef(null);

  useEffect(() => {
    const onMove = e => {
      pos.current = { x: e.clientX, y: e.clientY };
      if (dotRef.current) {
        dotRef.current.style.left = e.clientX + 'px';
        dotRef.current.style.top  = e.clientY + 'px';
      }
    };
    const animate = () => {
      ring.current.x += (pos.current.x - ring.current.x) * 0.13;
      ring.current.y += (pos.current.y - ring.current.y) * 0.13;
      if (ringRef.current) {
        ringRef.current.style.left = ring.current.x + 'px';
        ringRef.current.style.top  = ring.current.y + 'px';
      }
      raf.current = requestAnimationFrame(animate);
    };
    animate();
    document.addEventListener('mousemove', onMove);
    const hover = e => ringRef.current?.classList.toggle('scale-150', e.type === 'mouseenter');
    document.querySelectorAll('a,button,.glass-card').forEach(el => {
      el.addEventListener('mouseenter', hover);
      el.addEventListener('mouseleave', hover);
    });
    return () => { document.removeEventListener('mousemove', onMove); cancelAnimationFrame(raf.current); };
  }, []);


}
